import { createClient, fetchExchange, mapExchange } from '@urql/core'
import { getIntrospectedSchema, minifyIntrospectionQuery } from '@urql/introspection'
import { getIntrospectionQuery } from 'graphql'
import cacheExchange from './exchanges/cacheExchange'
import { GRAPHQL_ENDPOINT } from '../../_constants'
import authExchange from './exchanges/authExchange'

const getGraphQLHeaders = () => {
  const season = window.sessionStorage.getItem('season')
  const userID = window.localStorage.getItem('debug-user-id')

  return {
    ...(season ? { 'x-season': season } : {}),
    ...(userID ? { 'x-user-id': userID } : {}),
  }
}

fetch(GRAPHQL_ENDPOINT, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    ...getGraphQLHeaders(),
  },
  credentials: 'include',
  body: JSON.stringify({
    variables: {},
    query: getIntrospectionQuery({ descriptions: false }),
  }),
})
  .then(result => result.json())
  .then(({ data }) => {
    const minified = minifyIntrospectionQuery(getIntrospectedSchema(data));
    window.localStorage.setItem('schema', JSON.stringify(minified));
  });
/**
 * URQL Client for silverstripe
 *
 * @returns {*}
 */
const GraphQLClientSilverstripe = createClient({
  url: GRAPHQL_ENDPOINT,
  exchanges: [
    cacheExchange,
    authExchange,
    mapExchange({
      onError(error, _operation) {
        const isAuthError = error.graphQLErrors.some(e => e.message.includes('login erforderlich'))
          || error.graphQLErrors.some(e => e.message.includes('Bitte melde dich an, um fortzufahren'))
          || error.graphQLErrors.some(e => e.message.includes('The resource owner or authorization server denied the request'))
          || error.graphQLErrors.some(e => e.message.includes('Invalid token'));
        if (isAuthError) {
          const event = new CustomEvent("loginError");
          document.dispatchEvent(event)
        }
      },
    }),
    fetchExchange
  ],
  requestPolicy: 'cache-and-network',
  fetchOptions: () => {
    return {
      headers: {
        'x-socket-id': sessionStorage.getItem('socket-id'),
        ...getGraphQLHeaders()
      },
      credentials: 'include'
    }
  },
});

export default GraphQLClientSilverstripe;
